import React, { useState, useRef } from "react";
import "./CustomEditor.css";

// Helper function to insert a checkbox
const insertCheckbox = (editorRef: React.RefObject<HTMLDivElement>) => {
  if (editorRef.current) {
    const range = window.getSelection()?.getRangeAt(0);
    if (range) {
      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.className = "custom-checkbox";
      range.deleteContents();
      range.insertNode(checkbox);
    }
  }
};

// Toggle Bold Formatting
const toggleBold = () => {
  document.execCommand("bold");
};

const CustomEditor: React.FC = () => {
  const editorRef = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState<string>("");

  const handleInput = () => {
    if (editorRef.current) {
      setContent(editorRef.current.innerHTML);
    }
  };

  return (
    <div>
      {/* Formatting buttons */}
      <button onClick={toggleBold}>Bold</button>
      <button onClick={() => insertCheckbox(editorRef)}>Insert Checkbox</button>

      {/* Content editable div */}
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        className="editor"
        style={{
          border: "1px solid #ccc",
          minHeight: "200px",
          padding: "10px",
        }}
      />

      {/* Displaying raw HTML content */}
      <div>
        <h3>Content</h3>
        <pre>{content}</pre>
      </div>
    </div>
  );
};

export default CustomEditor;
